<template>
  <div
    class="garden-search-wrapper"
    :class="{ 'is-search-page': isSearchPage }"
  >
    <div class="search-input-wrapper">
      <b-input-group>
        <b-form-input
          id="gardenSearchInput"
          ref="gardenSearchInput"
          class="search-input-component"
          v-model="inputValue"
          :disabled="disabled"
          placeholder="Search by garden name"
          @keyup.enter="handleEnterEvent"
          @focus="searchInputFocused"
        />
      </b-input-group>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GardenSearch',

  props: {
    isSearchPage: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('garden', ['searchTerm', 'gardenSearchType']),

    isControlled() {
      return this.value !== undefined
    },

    inputValue: {
      get() {
        if (this.isControlled) {
          return this.value != null ? this.value : ''
        }
        return this.searchTerm || ''
      },
      set(val) {
        if (this.isControlled) {
          this.$emit('input', val)
        } else {
          this.$store.commit('garden/updateSearchTerm', val)
        }
      },
    },
  },

  mounted() {
    if (!this.isControlled) {
      this.updateSearchType(this.gardenSearchType)
    }
  },

  methods: {
    ...mapActions('garden', ['updateSearchType', 'searchGardens']),

    handleEnterEvent() {
      if (!this.isControlled && this.inputValue && this.inputValue.trim()) {
        this.searchGardens()
      }
      if (this.$refs.gardenSearchInput) {
        this.$refs.gardenSearchInput.blur()
      }
    },

    searchInputFocused() {
      if (!this.isControlled) {
        this.updateSearchType(this.gardenSearchType)
      }
    },
  },
}
</script>

<style lang="scss">
.garden-search-wrapper {
  flex: 1;

  &.is-search-page {
    .search-input-wrapper .input-group {
      border: 1px solid rgba($color-grey-dark, 0.2);
      border-radius: 4px;
      min-height: 40px;

      .form-control {
        border: none;
        min-height: 40px;
        padding: 10px 12px;
        font-family: "Gill Sans", "Inter", sans-serif;
        font-size: 18px;
        color: $color-grey-dark;

        &::placeholder {
          color: $color-grey-medium;
        }

        &:focus {
          box-shadow: none;
          border: none;
        }
      }
    }
  }

  .search-input-wrapper {
    width: 100%;

    .input-group {
      justify-content: center;
      position: relative;
      border: 1px solid $color-grey-dark;
      border-radius: 5px;
    }

    #gardenSearchInput {
      &:focus {
        box-shadow: none;
        border: 1px solid #ced4da;
      }
    }
  }
}
</style>
